import React from "react";
import * as S from "./Styles";

interface MenuButtonProps {
  isOpen?: boolean;
  toggleMenu?: () => void;
}

const MenuButton = ({ isOpen, toggleMenu }: MenuButtonProps) => {
  return (
    <S.Button
      type="button"
      onClick={toggleMenu}
      $isOpen={isOpen}
      aria-label={isOpen ? "Lukk meny" : "Åpne meny"}
      aria-expanded={isOpen}
      aria-controls="mobile-navigation">
      <S.Line $isOpen={isOpen} />
      <S.Line $isOpen={isOpen} />
      <S.Line $isOpen={isOpen} />
    </S.Button>
  );
};

export default MenuButton;
